import React from 'react';
import PropTypes from 'prop-types';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { alpha } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

import PlusIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/CloudDownload';

const styles = (theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    toolBar: {
      backgroundColor: '#cdf',
    },
    grow: {
      flexGrow: 1,
    },
    newItemButton: {
      margin: theme.spacing(1),
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20,
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block',
        maxWidth: '20%',
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: '40%',
      },
      fontFamily: 'MetricWebBold, sans-serif',
    },
    search: {
      backgroundColor: alpha(theme.palette.common.white, 0.2),
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.3),
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#cccccc !important',
        color: '#888888',
      },
      '& .Mui-focused': {
        color: '#999999',
      },
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
      },
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
    },
    inputInput: {
      border: 0,
      color: 'currentColor',
      boxSizing: 'content-box',
      background: 'none',
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(10),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 120,
        '&:focus': {
          width: 200,
        },
      },
    },
    downloadIcon: {
      marginRight: '10px',
    },
  });

const uniquifyCompanies = (companies) => {
  let names = [];
  let uniqueOptions = [];
  companies.forEach((co) => {
    const name = co.name;
    if (names.indexOf(name) < 0) {
      uniqueOptions = [...uniqueOptions, co];
      names = [...names, name];
    }
  });
  return uniqueOptions;
};

function CompanyTableAppBar(props) {
  const { classes, summary, newButtonLabel, newButtonFunc, companies, onAutocompleteChange, downloadFunc } = props;
  const uniqueCompanies = uniquifyCompanies(companies);
  return (
    <div className={classes.root}>
      <Toolbar className={classes.toolBar}>
        <Typography className={classes.title} variant="h5" color="inherit" noWrap>
          {summary}
        </Typography>
        <div className={classes.grow} />
        {newButtonLabel && (
          <Button className={classes.newItemButton} onClick={newButtonFunc}>
            <PlusIcon />
            {newButtonLabel}
          </Button>
        )}
        <div className={classes.grow} />
        <div className={classes.search}>
          <Autocomplete
            options={uniqueCompanies}
            getOptionLabel={(company) => company.name}
            style={{ width: 220 }}
            renderInput={(params) => <TextField {...params} label="Search" variant="outlined" />}
            onChange={(event, company) => onAutocompleteChange(company)}
          />
        </div>
        <div className={classes.grow} />
        <div className={classes.downloadIcon} onClick={() => downloadFunc()}>
          <Tooltip title="Download Companies">
            <DownloadIcon />
          </Tooltip>
        </div>
      </Toolbar>
    </div>
  );
}

CompanyTableAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  summary: PropTypes.string.isRequired,
};

export default withStyles(styles)(CompanyTableAppBar);
